"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
require("../../styles/components/success-flow-icon-label/success-flow-icon-label.less");
const SuccessFlowIconLabel = (0, react_1.memo)(({ className, successFlow: { display_name: name, icon_class: icon }, showLabel, onClick, showNotDefined, tooltipProps }) => {
    const component = (react_1.default.createElement("div", { className: `success-flow-icon-label ${className}`, onClick: onClick },
        react_1.default.createElement("div", { className: "custom-label-icon" },
            react_1.default.createElement("i", { className: `icon-class ${icon || (showNotDefined ? 'icon-UndefinedActivityType' : '')}` }),
            showLabel && react_1.default.createElement("span", { className: "success-flow-name" }, name || (showNotDefined ? 'undefined' : '')))));
    const { tooltipTitle, showArrow } = tooltipProps || {};
    return showLabel ? component : react_1.default.createElement(Tooltip_1.default, { title: tooltipTitle || name, arrow: showArrow, placement: "top" }, component);
});
SuccessFlowIconLabel.defaultProps = {
    className: '',
    showLabel: true,
    onClick: noop_1.default,
    showNotDefined: false,
    tooltipProps: {
        tooltipTitle: undefined,
        showArrow: false,
    },
};
SuccessFlowIconLabel.propTypes = {
    className: prop_types_1.default.string,
    successFlow: prop_types_1.default.exact({
        display_name: prop_types_1.default.string.isRequired,
        icon_class: prop_types_1.default.string.isRequired,
    }).isRequired,
    showLabel: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    showNotDefined: prop_types_1.default.bool,
    tooltipProps: prop_types_1.default.shape({
        tooltipTitle: prop_types_1.default.string,
        showArrow: prop_types_1.default.bool,
    }),
};
exports.default = SuccessFlowIconLabel;
//# sourceMappingURL=success-flow-icon-label.js.map